import React from "react";
import "../css/WhyJoinUsCareer.css";

const WhyJoinUsCareer = () => {
  const benefits = [
    {
      id: 1,
      image: "images/n.jpeg",
      icon: "🌍",
      title: "Global Environment",
      desc: "Work with diverse students and experienced educators while being part of an international learning environment that encourages creativity, innovation and excellence.",
    },
    {
      id: 2,
      image: "images/b.jpeg",
      icon: "🚀",
      title: "Growth Opportunities",
      desc: "We provide continuous professional development, training sessions and leadership opportunities to help every team member grow.",
    },
    {
      id: 3,
      image: "images/primary.jpg",
      icon: "💼",
      title: "Supportive Culture",
      desc: "Join a positive workplace where teachers and staff collaborate, share ideas and work together to create meaningful learning experiences.",
    },
    {
      id: 4,
      image: "images/pre.jpg",
      icon: "🎯",
      title: "Career Stability",
      desc: "Build a rewarding and secure career with a reputed educational institution focused on long-term growth and professional success.",
    },
  ];

  return (
    <section className="why-join-section">
      <div className="career-heading">
        <span>CAREER</span>

        <h2>Why Join Our School?</h2>

        <p>
          At Sahara Public School, we believe that great education begins with
          passionate people. Join our team and become a part of an inspiring
          environment where innovation, teamwork and growth are valued.
        </p>
      </div>

      <div className="benefits-grid">
        {benefits.map((item) => (
          <div className="benefit-card" key={item.id}>
            <div className="card-image-box">
              <img src={item.image} alt={item.title} />

              <div className="icon-box">
                {item.icon}
              </div>
            </div>

            <div className="card-content">
              <h3>{item.title}</h3>

              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyJoinUsCareer;